module.exports = __webpack_public_path__ + "img/novos-laudos.cd3ef04f.svg";